import React, { FC, ReactElement } from "react";
import {
  FacebookOutlined,
  LinkedinOutlined,
  TwitterOutlined,
  InstagramOutlined,
  YoutubeOutlined,
} from "@ant-design/icons";
import { Col, Row, Typography } from "antd";
import "./Footer.scss";

const Footer: FC = (): ReactElement => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-container">
      <Row
        gutter={[16, 16]}
        justify="space-between"
        align="middle"
        className="footer-top"
      >
        {/* Left Section */}
        <Col xs={24} md={12}>
          <Typography.Title level={4} className="footer-title">
            Dropkart Store
          </Typography.Title>
          <Typography.Text className="footer-text">
            Call us: <strong>+919032225598</strong>
          </Typography.Text>
          <br />
          <Typography.Text className="footer-text">
            Email us: <strong>dropkartworld29@gmail.com</strong>
          </Typography.Text>
          <br />
          <Typography.Text className="footer-text">Open 24/7</Typography.Text>
        </Col>

        {/* Right Section */}
        <Col xs={24} md={12} className="footer-social">
          <Typography.Title level={5} className="footer-follow-title">
            Follow us
          </Typography.Title>

          <div className="social-icons">
            <a
              href="https://www.linkedin.com/company/dropkart"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <LinkedinOutlined />
            </a>

            <a
              href="https://www.facebook.com/share/1CVZyrGRiZ/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FacebookOutlined />
            </a>

            <a
              href="https://x.com/dropkartworld29?t=vamrzGXccLCenSqSsJ_S6w&s=09"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
            >
              <TwitterOutlined />
            </a>

            <a
              href="https://www.instagram.com/dropkartapp?igsh=MWdjODVwazMxMDMzaw=="
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <InstagramOutlined />
            </a>

            <a
              href="https://youtube.com/@dropkart-f1c?si=mthvAQAVK0ZP27p6"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <YoutubeOutlined />
            </a>
          </div>
        </Col>
      </Row>

      {/* Bottom Section */}
      <Row justify="center" className="footer-bottom">
        <Typography.Text>
          © {currentYear} <strong>Dropkart Store</strong>. All rights reserved.
        </Typography.Text>
      </Row>

      {/* 🔹 Legal / Policy Links */}
      <div className="footer-links">
        <a href="/terms">Terms & Conditions</a>
        <a href="/privacy">Privacy Policy</a>
        <a href="/refund-policy">Refund & Returns</a>
        <a href="/shipping-policy">Shipping Info</a>
        <a href="/contact-us">Contact Us</a>
      </div>
    </footer>
  );
};

export default Footer;
